import styled from 'styled-components';

import { getButtonStyle } from '@/components/AdvertisePayments/components/Footer/Footer.helpers';
import { ButtonProps } from '@/components/AdvertisePayments/components/Footer/Footer.types';
import { Typography } from '@/components/ui/Typography/Typography.styles';
import { CONTAINER_MAX } from '@/constants/breakpoints';
import {
  cappedPaddingInline,
  flexCenterAligned,
  flexColumn
} from '@/styles/common';

export const FooterWrapper = styled.div<{ $isSticky?: boolean }>`
  width: 100%;
  ${flexCenterAligned};
  min-height: 84px;
  flex-shrink: 0;
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  ${cappedPaddingInline('var(--px-desktop)')};
  padding-bottom: 20px;

  @media (max-width: ${CONTAINER_MAX.tablet}) {
    min-height: 89px;
    align-items: start;
    padding: 10px 30px env(safe-area-inset-bottom);
    background-color: transparent;
    position: fixed;
  }
`;

export const ContentColumn = styled.div`
  ${flexColumn};
  align-items: center;
  gap: 10px;
  width: 100%;
`;

export const ActionButton = styled(Typography)
  .withConfig({
    shouldForwardProp: property =>
      !['$type', '$isDark', '$isLoading', '$variant'].includes(property)
  })
  .attrs({
    variant: 'title4'
  })<ButtonProps>`
  ${flexCenterAligned};
  width: 100%;
  min-height: 44px;
  border-radius: 28px;
  border: none;
  font-weight: 500;
  font-size: 15px;
  transition: background 0.3s ease, opacity 0.3s ease;
  background: var(--system-blue);
  opacity: ${({ $isLoading }) => ($isLoading ? 0.5 : 1)};
  cursor: ${({ $isLoading }) => ($isLoading ? 'wait' : 'pointer')};

  &:disabled {
    opacity:.5;
    cursor:not-allowed;
  }

  @media (max-width: ${CONTAINER_MAX.tablet}) {
    max-width: 100%;

    background: ${({ $type, $isDark }) =>
      getButtonStyle($type, $isDark).background};
  }

  @media (max-width: ${CONTAINER_MAX.mobileL}) {
    background: var(--system-blue);
  };

  &:hover {
    background: var(--system-deepBlue);
  }

`;

export const ActionButtonLabel = styled(Typography)
  .withConfig({
    shouldForwardProp: property =>
      !['$type', '$isDark', '$variant'].includes(property)
  })
  .attrs<ButtonProps>({
    variant: 'title4'
  })`
  color: ${({ $type, $isDark }) => getButtonStyle($type, $isDark).labelColor};

  @media (max-width: ${CONTAINER_MAX.tablet}) {
    color: ${({ $type, $isDark }) =>
      getButtonStyle($type, $isDark).labelColorTablet};
  }

  @media (max-width: ${CONTAINER_MAX.mobileL}) {
    color: ${({ $type, $isDark }) => getButtonStyle($type, $isDark).labelColor};
  }
`;

export const SpinnerWrapper = styled.div`
  ${flexCenterAligned};
`;

export const Spinner = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid var(--system-white);
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 20px;

  @media (max-width: ${CONTAINER_MAX.tablet}) {
    display: block;
  }
`;

export const CancelButton = styled(ActionButton)`
  width: 152px;
  background: var(--bg-secondary);

  &:hover {
    background: var(--bg-secondary);
  }

  @media (max-width: ${CONTAINER_MAX.tablet}) {
    display: none;
  }
`;

export const MainButton = styled(ActionButton)`
  width: 255px;
  background: var(--textAndLabels-main);

  &:hover {
    background: var(--primary-hover);
  }

  @media (max-width: ${CONTAINER_MAX.tablet}) {
    width: 100%;
  }
`;
